/*
 * Copyright (c) 2024 Kiyozz.
 *
 * All rights reserved.
 */

export enum Template {
  ReactViteJavaScript = 'react-vite',
  ReactViteTypeScript = 'react-vite-ts',
  MainOnlyTypeScript = 'main-ts',
  MainOnlyJavaScript = 'main',
  SvelteJavaScript = 'svelte',
  SvelteTypeScript = 'svelte-ts',
}
